import { WarningIcon } from 'assets/icons';
import { ReactNode, useEffect, useState } from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { BaseQuestionnaireRoute } from '../../routes/slice';
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
} from '../components/Accordion';
import Citizenship from '../PersonalDetails/TheBasics/Citizenship';
import CovidRelief from '../PersonalDetails/TheBasics/CovidRelief';
import Logistics from '../PersonalDetails/TheBasics/Logistics';
import Name from '../PersonalDetails/TheBasics/Name';
import PastFillings from '../PersonalDetails/TheBasics/PastFillings';

interface ISecondLevelSubTabs {
  mainTabPath: string;
  firstLevelSubTabPath: string;
  subTabs: BaseQuestionnaireRoute;
}

const SecondLevelSubTabs = ({
  mainTabPath,
  firstLevelSubTabPath,
  subTabs,
}: ISecondLevelSubTabs) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState<string>('');

  useEffect(() => {
    const pathParts = location?.pathname?.split('/').slice(4);
    pathParts && setOpen(pathParts[2]);
  }, [location]);

  const secondLevelSubTabs = Object.values(subTabs);

  return (
    <>
      {secondLevelSubTabs.map((subTab) => {
        const { path: secondLevelTabPath, title, isValid } = subTab;

        return (
          <Accordion
            key={title}
            open={open === secondLevelTabPath}
            onClick={() =>
              navigate(
                `${mainTabPath}/${firstLevelSubTabPath}/${secondLevelTabPath}`,
              )
            }
            className="border-t px-2"
          >
            <AccordionHeader className="text-sm font-medium">
              <div className="flex">
                {title}
                {isValid === 'notValid' && (
                  <WarningIcon className="w-4 ml-auto mr-4" />
                )}
              </div>
            </AccordionHeader>
            <AccordionBody>
              {open === secondLevelTabPath ? <Outlet /> : <></>}
            </AccordionBody>
          </Accordion>
        );
      })}
    </>
  );
};

export default SecondLevelSubTabs;
